<app-header-menu-lite></app-header-menu-lite>
<main class="content" id="content" tabindex="-1">
  <cc-dash class="dash"></cc-dash>
  <cc-dock class="dock"></cc-dock>
  <app-footer-with-environment-informations></app-footer-with-environment-informations>
</main>


<!--<app-parallax-bg-->
<!--  [maxPctX]="8"-->
<!--  [maxPctY]="5"-->
<!--  [bleed]="100"-->
<!--  [easing]="0.08"-->
<!--  [respectReducedMotion]="appConfigService.respectReducedMotion"-->
<!--  [preventMotion]="appConfigService.preventMotion"-->
<!--&gt;-->
<!--  <main class="content" id="content" tabindex="-1">-->
<!--    <cc-dash class="dash"></cc-dash>-->
<!--    <cc-dock class="dock"></cc-dock>-->
<!--  </main>-->
<!--</app-parallax-bg>-->
